exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-common-adjust-columns .modal-dialog{width:280px}#modal-common-adjust-columns .adjust-columns-drag-handle{cursor:-webkit-grab;cursor:grab}#modal-common-adjust-columns .adjust-columns-drag-handle:active{cursor:-webkit-grabbing;cursor:grabbing}#modal-common-adjust-columns .adjust-columns-pinned td{border-bottom:1px solid #dee2e6}#modal-common-adjust-columns tr.adjust-columns-dragging{opacity:.5;background:#f8f9fa}", ""]);

// exports
